import { Components } from '@mui/material/styles'

export const MuiChipOverrides: Components['MuiChip'] = {
  styleOverrides: {
    root: {
      borderRadius: 2, // 16px (2 * 8px)
      height: 32,
    },
  },
}
